import { useQuery } from "@tanstack/react-query";
import { getJobBenefitList } from "app/api/benefit_api";

export const useGetBenefits = ({ keys, limit, offset, name, staleTime = Infinity }) => {
  return useQuery({
    queryKey: ["get_benefits", ...keys, limit, offset, name],
    queryFn: () => getJobBenefitList({ limit, offset, name }),
    staleTime: staleTime
  });
};
